// Organization-wide ingestion health (agion/Agion#2091).
//
// One request answers which of the organization's governed sources need
// attention, and which hosts could not be read. Governance fans out across the
// hosts, so this read is slower than an ordinary one and carries the same
// timeout the other fan-out reads use.
//
// Concurrent readers share one request through the useOrgIngestionHealth
// query key rather than a dedupe here: N mounted readers must not become N
// fan-outs across every Edge host.
import { api } from '@/shared/api/client'
import type { IngestionHealth } from '@/types/ingestion-health.types'

const FANOUT_REQUEST_OPTIONS = {
  timeout: 25000,
  retry: 0,
} as const

class IngestionHealthService {
  async getOrgIngestionHealth(): Promise<IngestionHealth> {
    return api.get<IngestionHealth>(
      'governance/intelligence/ingestion-health',
      undefined,
      FANOUT_REQUEST_OPTIONS,
    )
  }
}

export const ingestionHealthService = new IngestionHealthService()
